// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatIcon_container__1vgd1","wrapper":"ChatIcon_wrapper__2X6IU","chatbox":"ChatIcon_chatbox__2J23x"};